import { API_KEY } from "./constants/Constants"
export const originals =`discover/tv?api_key=${API_KEY}&with_networks=213`
export const action = `discover/movie?api_key=${API_KEY}&with_genres=28`
export const comedy = `discover/movie?api_key=${API_KEY}&with_genres=35`
export const horror = `discover/movie?api_key=${API_KEY}&with_genres=27`
export const actionmovies = `discover/movie?api_key=${API_KEY}&with_genres=28`
export const romcom = `discover/movie?api_key=${API_KEY}&with_genres=10749`
export const Documentries = `discover/movie?api_key=${API_KEY}&with_genres=99`
